module.exports = __webpack_public_path__ + "media/images/yellow-bubble-178ec522addecfb263f76904dc75bf59.png";